import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import { post as doLogout } from 'actions/logout';

import { connect } from 'react-redux';
import { Button } from '@cuemath/comps';
import { REDIRECT_CONSTANTS } from 'constants/constants';
import { Text } from '@cuemath/web-comps';

const { REDIRECT_URL, HOME_ROUTE } = REDIRECT_CONSTANTS;
class Logout extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      doLogout: PropTypes.func.isRequired,
    }).isRequired,
  };

  static getDerivedStateFromProps({ logout }, state) {
    return {
      logoutPost: store.post(logout, state.logoutPost.id),
    };
  }

  state = {
    logoutPost: store.post(),
  };

  doLogout = () => {
    const {
      logoutPost: { id, current },
    } = this.state;
    const { actions } = this.props;

    localStorage.setItem(REDIRECT_URL, HOME_ROUTE); // so Private routes does'nt set redirectURl again.

    if (current && current.isCreating) {
      return;
    }

    actions.doLogout(id);
  };

  render() {
    return <Text onClick={this.doLogout}>Logout</Text>;
  }
}

export default connect(
  ({ logout }) => ({ logout }),
  dispatch => ({
    actions: bindActionCreators({ doLogout }, dispatch),
  }),
)(Logout);
